var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"max-w-5xl mx-auto space-y-16"},[_c('AdsetListComponent',{attrs:{"fetching":_vm.fetching,"adsets":_vm.adsets,"meta":_vm.meta},on:{"get-adsets":_vm.handleGetAdsets}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }